import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-time-split',
  templateUrl: './time-split.component.html',
  styleUrls: ['./time-split.component.css']
})
export class TimeSplitComponent implements OnInit {
  timeSplit: any = {
    hour: false, min: false, sec: true
  }
  @Output() timeSplitKey = new EventEmitter<any>();


  constructor() { }

  ngOnInit(): void {
  }

  ontimeSplit(time: string) {
    this.timeSplit = {
      hour: false, min: false, sec: false
    };
    this.timeSplit[time] = true;
    this.timeSplitKey.emit(time);
  }
}
